import React from 'react';
import { Button, Row, Col, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './styles.scss';

const FormButtons = ({
  calcelTooltipID,
  cancelOnClick,
  cancelTitle,
  saveOnClick,
  saveTitle,
  saveTooltipID,
  size,
  withCancel,
  disabledSuccess,
  isLoading,
  saveButtonClassName,
  justify,
  ...props
}) => {
  const defaultJustify = withCancel ? 'justify-content-between' : 'justify-content-end';
  const justifyClass = justify ? `justify-content-${justify}` : defaultJustify;
  const wrapperClass = `my-5 pt-5 row no-gutters px-4 mx-2 ${justifyClass}`;
  const buttonClass = saveButtonClassName ? `next-button ${saveButtonClassName}` : 'next-button';
  return (
    <Row className={wrapperClass} noGutters>
      {withCancel && (
        <Col xs="auto">
          <Button className="back-button text-center" size={size} onClick={cancelOnClick} {...props}>
            <span className="px-3 py-0"> {cancelTitle} </span>
          </Button>
        </Col>
      )}
      <Col xs="auto">
        <Button
          className={`${buttonClass} text-center px-md-2`}
          size={size}
          type="submit"
          onClick={saveOnClick}
          disabled={disabledSuccess || isLoading}
          {...props}
        >
          <span className="px-3 py-0">
            {isLoading ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                <span className="sr-only">Cargando...</span>
              </>
            ) : (
              saveTitle
            )}
          </span>
        </Button>
      </Col>
    </Row>
  );
};

FormButtons.propTypes = {
  calcelTooltipID: PropTypes.string,
  cancelOnClick: PropTypes.func,
  cancelTitle: PropTypes.string,
  saveOnClick: PropTypes.func,
  saveTitle: PropTypes.string,
  saveTooltipID: PropTypes.string,
  size: PropTypes.string,
  withCancel: PropTypes.bool,
  disabledSuccess: PropTypes.bool,
  isLoading: PropTypes.bool,
  saveButtonClassName: PropTypes.string,
  justify: PropTypes.string
};

FormButtons.defaultProps = {
  calcelTooltipID: 'nn-cancel-btn',
  cancelOnClick: () => {},
  cancelTitle: 'Cancelar',
  saveOnClick: () => {},
  saveTitle: 'Guardar',
  saveTooltipID: 'nn-save-btn',
  size: 'md',
  withCancel: false,
  disabledSuccess: false,
  isLoading: false,
  saveButtonClassName: '',
  justify: ''
};

export default FormButtons;
